import { render, staticRenderFns } from "./o-list-work.vue?vue&type=template&id=5e36a96a&scoped=true"
import script from "./o-list-work.vue?vue&type=script&lang=js"
export * from "./o-list-work.vue?vue&type=script&lang=js"
import style0 from "./o-list-work.vue?vue&type=style&index=0&id=5e36a96a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36a96a",
  null
  
)

export default component.exports